import { defineStore } from 'pinia';
import { computed, ref } from 'vue'
import { requestBuilder } from '@/utils/request-builder.utilities.js'
import { processResponse } from '@/utils/process-response-utilities.js'
import { instance } from '@/plugins/axios.js'
import {
  permissionRequestConfig,
  permittedUsers
} from '@/config/permissions.constant.js'
import { useAuthStore } from '@/stores/useAuthStore.js'

const {getAllRecords} = requestBuilder()
export const usePermissionStore = defineStore('permission', () => {
  const permissions = ref([]);
  const isLoading = ref(false);
  const isLoaded = ref(false);
  let inFlightRequest = null;
  const userURL = computed(() => {
    return import.meta.env.VITE_USERS_API_URL + 'request'
  })

   const getPermissions = async () => {
    if (inFlightRequest) return inFlightRequest;
    const authStore = useAuthStore()
    isLoading.value = true;
    inFlightRequest = (async () => {
      try {
        const {data:res} = await instance.post(userURL.value, {
          request: permissionRequestConfig.request,
          type: permissionRequestConfig.type.authUserList
        })
        const isResponseOk = processResponse(res);
        permissions.value = isResponseOk && Array.isArray(res.data) ? res.data : [];
        isLoaded.value = isResponseOk;
        isPermittedUser(authStore.getUserLogInfo?.code)
      } catch (error) {
        console.error('Failed to load permissions:', error);
        permissions.value = [];
        isLoaded.value = false;
      } finally {
        isLoading.value = false;
        inFlightRequest = null;
      }
    })();
    return inFlightRequest;
   };

  const setPermissions = (newPermissions) => {
    permissions.value = newPermissions;
  };

  const clearPermissions = () => {
    permissions.value = [];
    isLoaded.value = false;
  }
   const hasPermission = (permission) => {
    return permissions.value.includes(permission);
  };

  const hasAnyPermission = (requiredPermissions) => {
    if (!Array.isArray(requiredPermissions)) return false;
    return requiredPermissions.some((perm) => permissions.value.includes(perm));
  };

  const hasAllPermissions = (requiredPermissions) => {
    if (!Array.isArray(requiredPermissions)) return false;
    return requiredPermissions.every((perm) => permissions.value.includes(perm));
  };

  const isPermittedUser = (username) => {
    if (permittedUsers.includes(username)) {
      permissions.value = [...new Set([...permissions.value, 'permission.list'])]
    }
  }

  return {
    permissions,
    isLoading,
    isLoaded,

    getPermissions,
    setPermissions,
    clearPermissions,

    hasPermission,
    hasAnyPermission,
    hasAllPermissions,

    isPermittedUser
  };
});
